"use client";

import { useEffect } from "react";

interface GlobalErrorProps {
    error: Error & { digest?: string };
    reset: () => void;
}

const PANIC_ART = `
  ╔══════════════════════════════════════╗
  ║     *** SYSTEM PANIC ***             ║
  ║                                      ║
  ║     ░░░░  ▓▓▓▓  ░░░░  ▓▓▓▓          ║
  ║     ▓▓▓▓  ░░░░  ▓▓▓▓  ░░░░          ║
  ║                                      ║
  ║     a fault has occurred at 0x404    ║
  ║     please reload the universe       ║
  ╚══════════════════════════════════════╝
`;

export default function GlobalError({ error, reset }: GlobalErrorProps) {
    useEffect(() => {
        console.error(error);
    }, [error]);

    return (
        <html lang="en">
            <body
                style={{
                    margin: 0,
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#000080",
                    color: "#ffffff",
                    fontFamily:
                        "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
                    padding: "2rem",
                }}
            >
                <div style={{ maxWidth: "44rem", width: "100%" }}>
                    <pre
                        style={{
                            margin: 0,
                            fontSize: "0.7rem",
                            lineHeight: 1.2,
                            whiteSpace: "pre",
                            overflowX: "auto",
                            color: "#ffeb3b",
                        }}
                    >
                        {PANIC_ART}
                    </pre>

                    <h1
                        style={{
                            fontSize: "1.25rem",
                            fontWeight: 700,
                            letterSpacing: "0.05em",
                            margin: "1.5rem 0 0",
                        }}
                    >
                        KERNEL PANIC · ERROR CRÍTICO
                    </h1>
                    <p style={{ fontSize: "0.875rem", opacity: 0.85, marginTop: "0.5rem" }}>
                        The app failed to start. / La aplicación no pudo arrancar.
                    </p>

                    <div
                        style={{
                            marginTop: "1.5rem",
                            padding: "0.75rem 1rem",
                            border: "1px solid rgba(255,255,255,0.3)",
                            background: "rgba(0,0,0,0.25)",
                            fontSize: "0.75rem",
                            lineHeight: 1.6,
                        }}
                    >
                        <div style={{ color: "#ff8080" }}>
                            [FATAL] {error.message || "unknown error"}
                        </div>
                        {error.digest && (
                            <div style={{ opacity: 0.7, marginTop: "0.25rem" }}>
                                trace={error.digest}
                            </div>
                        )}
                    </div>

                    <button
                        type="button"
                        onClick={reset}
                        style={{
                            marginTop: "1.5rem",
                            background: "#ffffff",
                            color: "#000080",
                            border: 0,
                            font: "inherit",
                            fontSize: "0.8rem",
                            fontWeight: 700,
                            letterSpacing: "0.05em",
                            cursor: "pointer",
                            padding: "0.5rem 1rem",
                        }}
                    >
                        ↻ RELOAD · RECARGAR
                    </button>

                    <p
                        style={{
                            marginTop: "2rem",
                            fontSize: "0.7rem",
                            opacity: 0.5,
                        }}
                    >
                        Press any key to continue_ █
                    </p>
                </div>
            </body>
        </html>
    );
}
